import React, { useState, useEffect } from "react";
import * as Steps from './index';
import { getSessionStorageItem, setSessionStorageItem, getBasicInfo, SESSION_STORAGE_BASIC_INFO_KEY, SESSION_STORAGE_CUSTOMIZED_HEALTH_KEY } from '../../../../sessionStorage';
import { saveSessionEvent } from "../../../../session";
import '../../MCT/MCT.scss';
import TobaccoUsage from "../../Common/Helpers/TobaccoUsage";
import TermData from "../../../Helpers/Data/Products/Term/TermData";
import { HeaderProgressTracker } from "../../Common/HeaderStepper/HeaderProgressTracker";
import './HealthClassCalcButton.scss'

export default function HealthClassSteps(props) {

  useEffect(() => { saveSessionEvent() }, [props.location])

  const basicInfo = getBasicInfo();

  const newFormState = {
    currentStep: 1,
    pages: {
      myHealthProfile: Steps.MyHealthProfile.DefaultFormState(null, basicInfo),
      background: Steps.Background.DefaultFormState(null, basicInfo),
      tobaccoUse: Steps.TobaccoUse.DefaultFormState(null, basicInfo),
      adventures: Steps.Adventures.DefaultFormState(null, basicInfo),
      drivingRecord: Steps.DrivingRecord.DefaultFormState(),
      familyHistory: Steps.FamilyHistory.DefaultFormState(null, basicInfo),
      medicalDetails: Steps.MedicalDetails.DefaultFormState(null),
      medicalHistory: Steps.MedicalHistory.DefaultFormState(null, basicInfo),
      alcoholDrugAbuse: Steps.AlcoholDrugAbuse.DefaultFormState(null, basicInfo),
    },
  }
  const sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_CUSTOMIZED_HEALTH_KEY);
  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);
  const termData = TermData();
  const basicInfoTobacco = getSessionStorageItem(SESSION_STORAGE_BASIC_INFO_KEY);
  const showMedicalDetailsPage = formState.pages.myHealthProfile.personalHistoryMedical && (formState.pages.medicalHistory.hypertensionOrHighBloodPressure || formState.pages.medicalHistory.highCholesterol || formState.pages.medicalHistory.diabetes)

  const showDrivingRecordPage = formState.pages.background.TwoMovingViolations || formState.pages.background.recklessDrivingOrDUI
  let tobaccoUsage = TobaccoUsage(basicInfoTobacco && basicInfoTobacco.tobacco);

  const onNext = () => {

    let nextStep = steps.find(s => s.step === formState.currentStep + 1);
    getHealthClass({...formState, aboutMe: {...basicInfoTobacco}});

    if (nextStep && nextStep.path === "tobacco-use" && tobaccoUsage === "false") {
      nextStep = steps.find(s => s.step === nextStep.step + 1);
    }

    if (nextStep && nextStep.path === 'medical-history' && !formState.pages.myHealthProfile.personalHistoryMedical) {
      nextStep = steps.find(s => s.step === nextStep.step + 1);
    }

    if (nextStep && nextStep.path === 'medical-details' && showMedicalDetailsPage === false) {
      nextStep = steps.find(s => s.step === nextStep.step + 1);
    }

    if (nextStep && nextStep.path === 'family-history' && !formState.pages.myHealthProfile.familyHistory) {
      nextStep = steps.find(s => s.step === nextStep.step + 1);
    }

    if (nextStep && nextStep.path === 'alcohol-drug-abuse' && !formState.pages.myHealthProfile.treatedAlcoholSubstanceAbuse) {
      nextStep = steps.find((s) => s.step === nextStep.step + 1);
    }

    if (nextStep && nextStep.path === 'driving-record' && showDrivingRecordPage === false) {
      nextStep = steps.find((s) => s.step === nextStep.step + 1);
    }

    if (nextStep && nextStep.path === 'adventures' && formState.pages.background.hazardousActivities === false) {
      nextStep = steps.find((s) => s.step === nextStep.step + 1);
    }

    if (nextStep === undefined) {
      const newFormState = { ...formState, currentStep: 1};

      setFormState(newFormState);
      sessionStorage.setItem(SESSION_STORAGE_CUSTOMIZED_HEALTH_KEY, JSON.stringify(newFormState));
      props.setModalHealthCalcIsOpen(false);
      return;
    }

    const newFormState = { ...formState, currentStep: nextStep.step};
    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_CUSTOMIZED_HEALTH_KEY, JSON.stringify(newFormState));
  }

  const onBack = () => {
    let backStep = steps.find(s => s.step === formState.currentStep - 1);
    if (backStep === undefined) {
      props.setModalHealthCalcIsOpen(false);
      return;
    }
    getHealthClass({...formState, aboutMe: {...basicInfoTobacco}});
    if (backStep.path === 'adventures' && formState.pages.background.hazardousActivities === false) {
      backStep = steps.find((s) => s.step === backStep.step - 1);
    }

    if (backStep.path === 'driving-record' && showDrivingRecordPage === false) {
      backStep = steps.find((s) => s.step === backStep.step - 1);
    }

    if (backStep.path === 'alcohol-drug-abuse' && !formState.pages.myHealthProfile.treatedAlcoholSubstanceAbuse) {
      backStep = steps.find((s) => s.step === backStep.step - 1);
    }

    if (backStep.path === 'family-history' && !formState.pages.myHealthProfile.familyHistory) {
      backStep = steps.find(s => s.step === backStep.step - 1);
    }

    if (backStep.path === 'medical-details' && showMedicalDetailsPage === false) {
      backStep = steps.find(s => s.step === backStep.step - 1);
    }

    if (backStep.path === 'medical-history' && !formState.pages.myHealthProfile.personalHistoryMedical) {
      backStep = steps.find(s => s.step === backStep.step - 1);
    }

    if (backStep.path === "tobacco-use" && tobaccoUsage === "false") {
      backStep = steps.find(s => s.step === backStep.step - 1);
    }

    const newFormState = { ...formState, currentStep: backStep.step }
    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_CUSTOMIZED_HEALTH_KEY, JSON.stringify(newFormState));
  }

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  }

  const resetHealthProfileValues = (step) => {
    setFormState({
      ...formState,
      pages: {
        ...formState.pages,
        [step]: {
          ...formState.pages[step],
          personalHistoryMedical: false,
          hospitalized: false,
          familyHistory: false,
          treatedAlcoholSubstanceAbuse: false,
        },
      },
    });
  };

  const calculatePercentage = (totalStep, step, categoryStep, currentCateTotalStep) => {
    let stepPer = ((step - 1) / totalStep * 100);
    let cateCount = currentCateTotalStep === 1 ? 1 : (((categoryStep - 0.5) / currentCateTotalStep) * (100 / totalStep));
    return stepPer + cateCount;
  }

  const getHealthClass = (healthProfile) => {
    const profile = {aboutMe: healthProfile.aboutMe, ...healthProfile.pages}
    delete profile.aboutMe.bmi;

    fetch(`${process.env.REACT_APP_COVR_SERVICES_URL}/api/VSS/GetCustomHealthClass`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(profile),
    })
      .then(res => res.json())
      .then(json => {
        props.onHealthClassChange(json.defaultHealthClass);
      });
  }

  // not able to set multiple field value change at one time, for work none checkbox need to reset vales
  const resetPersonalizeOptions = (step) => {
    setFormState({
      ...formState, pages:
      {
        ...formState.pages,
        [step]: {
          ...formState.pages[step],
          TwoMovingViolations: false,
          recklessDrivingOrDUI: false,
          chargedFelony: false,
          bankruptcyWithinLast5Years: false,
          receivingSSOrDisabled: false,
          hazardousActivities: false,
        }
      }
    });
  }

  const steps = [
    {
      step: 1,
      path: 'my-health-profile',
      progressTitle: 'Health History',
      component: (
        <Steps.MyHealthProfile
          formState={formState.pages.myHealthProfile}
          basicInfo={basicInfo}
          onFieldChange={(field, value) => onFieldChange('myHealthProfile', field, value)}
          onNext={onNext}
          onBack={onBack}
          isCustomizeTerm={true}
          resetHealthProfileValues={() => resetHealthProfileValues('myHealthProfile')}
          coverageAmountSpecs={termData.specs.coverageAmount}
        />
      ),
      categoryNumber: 1,
      categoryStep: 1,
      showContainer: true,
    },
    {
      step: 2,
      path: 'background',
      progressTitle: 'Personal History',
      component: (
        <Steps.Background
          formState={formState.pages.background}
          healthProfileFormState={formState.pages.myHealthProfile}
          basicInfo={basicInfo}
          onFieldChange={(field, value) => onFieldChange('background', field, value)}
          onNext={onNext}
          isCustomizeTerm={true}
          onBack={onBack}
          resetPersonalizeOptions={resetPersonalizeOptions}
          coverageAmountSpecs={termData.specs.coverageAmount}
        />
      ),
      categoryNumber: 2,
      categoryStep: 1,
      showContainer: true,
    },
    {
      step: 3,
      path: 'tobacco-use',
      progressTitle: 'Tobacco Use',
      component: (
        <Steps.TobaccoUse
          formState={formState.pages.tobaccoUse}
          basicInfo={basicInfo}
          onFieldChange={(field, value) => onFieldChange('tobaccoUse', field, value)}
          onNext={onNext}
          onBack={onBack}
          coverageAmountSpecs={termData.specs.coverageAmount}
        />
      ),
      categoryNumber: 3,
      categoryStep: 1,
      showContainer: true,
    },
    {
      step: 4,
      path: 'medical-history',
      progressTitle: 'Personalize',
      component: (
        <Steps.MedicalHistory
          formState={formState.pages.medicalHistory}
          onFieldChange={(field, value) => onFieldChange('medicalHistory', field, value)}
          onNext={onNext}
          onBack={onBack}
        />
      ),
      categoryNumber: 3,
      categoryStep: 2,
      showContainer: true,
    },
    {
      step: 5,
      path: 'medical-details',
      progressTitle: 'Personalize',
      component: (
        <Steps.MedicalDetails
          formState={formState.pages.medicalDetails}
          medicalHistory={formState.pages.medicalHistory}
          onFieldChange={(field, value) => onFieldChange('medicalDetails', field, value)}
          onNext={onNext}
          onBack={onBack}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          fullFormState={formState}
        />
      ),
      categoryNumber: 3,
      categoryStep: 3,
      showContainer: true,
    },
    {
      step: 6,
      path: 'family-history',
      progressTitle: 'Personalize',
      component: (
        <Steps.FamilyHistory
          formState={formState.pages.familyHistory}
          onFieldChange={(field, value) => onFieldChange('familyHistory', field, value)}
          onNext={onNext}
          onBack={onBack}
        />
      ),
      categoryNumber: 3,
      categoryStep: 4,
      showContainer: true,
    },
    {
      step: 7,
      path: 'alcohol-drug-abuse',
      progressTitle: 'Personalize',
      component: (
        <Steps.AlcoholDrugAbuse
          formState={formState.pages.alcoholDrugAbuse}
          onFieldChange={(field, value) => onFieldChange('alcoholDrugAbuse', field, value)}
          onNext={onNext}
          onBack={onBack}
        />
      ),
      categoryNumber: 3,
      categoryStep: 5,
      showContainer: true,
    },
    {
      step: 8,
      path: 'driving-record',
      progressTitle: 'Personalize',
      component: (
        <Steps.DrivingRecord
          formState={formState.pages.drivingRecord}
          onFieldChange={(field, value) => onFieldChange('drivingRecord', field, value)}
          onNext={onNext}
          onBack={onBack}
        />
      ),
      categoryNumber: 3,
      categoryStep: 6,
      showContainer: true,
    },
    {
      step: 9,
      path: 'adventures',
      progressTitle: 'Personalize',
      component: (
        <Steps.Adventures
          formState={formState.pages.adventures}
          onFieldChange={(field, value) => onFieldChange('adventures', field, value)}
          onNext={onNext}
          onBack={onBack}
        />
      ),
      categoryNumber: 3,
      categoryStep: 7,
      showContainer: true,
    },
  ];

  const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];
  const categories = steps.filter((o) => o.categoryNumber === currentStepObj.categoryNumber);
  const totalCategoriesStep = Math.max.apply(Math, categories.map(function (o) { return o.categoryStep; }))
  const percent = calculatePercentage(3, currentStepObj.categoryNumber, currentStepObj.categoryStep, totalCategoriesStep);

  return (
    <div>
      <HeaderProgressTracker showOnlyProgressTracker={true} title={currentStepObj.title} hidden={currentStepObj.hidden} showContainer={currentStepObj.showContainer} hideProgressTracker={currentStepObj.hideProgressTracker} headerProductsText={true} stepName={currentStepObj.progressTitle} step={currentStepObj.categoryNumber} totalSteps={3} whiteBg={currentStepObj.whiteBackground} percent={percent} fullWidth={currentStepObj.fullWidth}>
        <div className="CustomizeTerm">
          {currentStepObj.component}
        </div>
      </HeaderProgressTracker>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/HealthClassCalculator/HealthClassSteps.js